export default function SectionTitle({ children, className = '' }) {
  return (
    <h2
      className={`font-serif font-medium leading-[1.1] text-ink ${className}`}
      style={{ fontSize: 'clamp(36px, 5vw, 56px)' }}
    >
      {children}
    </h2>
  );
}
